import AppIcon from 'shared/assets/MineCards-Logo-Rounded.svg'
import cls from './MinecardsLoader.module.scss'
import { Loader } from 'shared/ui/Loader'
// import Snowfall from 'react-snowfall'

export const MinecardsLoader = () => {
    return (
        <div className={cls.Container}>
            {/* <Snowfall
                color="#fff"
            /> */}
            <img className={cls.Icon} src={AppIcon} alt="MineCards" />
            <div className={cls.Text}>Мечтай по-новому</div>
            <Loader className={cls.loader} />
        </div>
    )
}
